import { ApiError } from "@/shared/api/client";
import { AI_CODE_MESSAGES, errorMessage } from "@/shared/lib/errors";
import { Alert } from "@/shared/ui";

/** True for the AI module's own errors (ai_disabled, ai_quota_exceeded…). */
// eslint-disable-next-line react-refresh/only-export-components
export const isAiError = (error: unknown): error is ApiError => error instanceof ApiError && error.code in AI_CODE_MESSAGES;

/** Vietnamese message for an AI call's failure (any error: non-AI ones fall back to the generic text). */
// eslint-disable-next-line react-refresh/only-export-components
export const aiErrorMessage = (error: unknown): string => errorMessage(error);

const WARNING_CODES = new Set(["ai_disabled", "premium_required", "ai_quota_exceeded", "ai_input_flagged"]);

/** Alert for a failed AI call; nothing when there is no error. Expected refusals (quota, disabled…) are warnings. */
export function AiErrorMessage({ error, title }: { error: unknown; title?: string }) {
  if (!error) return null;
  const tone = isAiError(error) && WARNING_CODES.has(error.code) ? "warning" : "danger";
  return <Alert tone={tone} title={title}>{aiErrorMessage(error)}</Alert>;
}
